<script setup>
// ============================================================================
// BonBoZ: LƯỚI TAG MÀU ngay dưới khung chat — đặc sản Pancake.
//
// Trong Pancake, dưới khung soạn tin là một lưới kín các tag màu (INTENT_,
// COHORT_, SPAM, DV_*, LOC_*, SĐT, HẸN...). Nhân viên bấm một phát là gắn/gỡ
// tag cho hội thoại, không rời khung chat. Đây là thao tác lặp lại nhiều nhất
// của trực page — Chatwoot bắt mở sidebar rồi gõ tìm label, chậm hơn hẳn.
//
// TAG THEO TRANG (Pancake: mỗi page một bộ tag): label Chatwoot thuộc cả
// account, phần "thuộc trang nào" là ánh xạ riêng lưu ở cấu hình theo trang
// (helper/pageConfig.js). Trang chưa cấu hình -> hiện tất cả. Không nạp được
// -> cũng hiện tất cả: mất phần lọc theo trang chứ không mất chức năng gắn tag.
//
// Khai bộ tag làm ở Cài đặt -> Tag theo trang, KHÔNG làm trong khung chat:
// gắn tag là việc lặp cả ngày của trực page, khai tag là việc quản trị làm một
// lần. Ở đây chỉ còn đúng thao tác gắn/gỡ.
//
// Tái dùng nguyên bộ máy label của Chatwoot (useConversationLabels): tag gắn
// từ lưới vẫn hiện chip trong danh sách hội thoại, vẫn lọc theo label được.
//
// KHÔNG dùng fluent-icon ở đây (bẫy tên icon đã cắn một lần, xem
// crm/README.md và scripts/kiem_icon.js).
// ============================================================================
import { computed } from 'vue';
import { useWindowSize } from '@vueuse/core';
import wootConstants from 'dashboard/constants/globals';
import {
  bienCssThe,
  useTheHoiThoai,
} from 'dashboard/composables/useTheHoiThoai';

const { labelsHien, isActive, toggle } = useTheHoiThoai();

// BonBoZ: luoi nay CHI danh cho may tinh. Tren dien thoai no an ba hang cua
// mot man hinh von da chat, ma Pancake ban dien thoai cung khong de o day —
// ho dua vao nut the tren thanh tieu de (xem `BangGanThe.vue`).
const { width: beNgangMan } = useWindowSize();
const laDienThoai = computed(
  () => beNgangMan.value < wootConstants.SMALL_SCREEN_BREAKPOINT
);
const hienLuoi = computed(() => !laDienThoai.value && labelsHien.value.length);
</script>

<template>
  <!-- wrapper luon render de khong pham vue/no-root-v-if; rong thi khong co
       style nao nen vo hinh.
       Nen be + dem duoi nam O DAY chu khong o khoi cuon ben trong: khoi do
       chiu tran `max-h`, them dem vao la an bot mot phan hang chip cuoi (dem
       tinh vao trong tran, `box-sizing: border-box`). O ngoai thi dem chi day
       khung soan tin xuong, khong dong den phep tinh so hang. -->
  <div :class="hienLuoi ? 'bg-[rgb(var(--pk-chat-nen))] pb-1.5' : ''">
    <!-- BonBoZ: LUOI `auto-fill` chu khong phai hang flex-wrap.
         Ban cu cho chip mot be ngang co dinh (88/96/104px) roi de flex tu
         xuong dong. Cho deu hang that, nhung hang nao cung du ra mot mieng
         trong o mep phai — be ngang khung hiem khi chia het cho 88+4, va cho
         thua do co the gan bang mot chip nua. Nhin ra la luoi tag khong bao gio
         cham duoc le phai.
         `repeat(auto-fill, minmax(Xpx, 1fr))`: trinh duyet nhet duoc bao nhieu
         cot rong >= X thi nhet, roi CHIA DEU cho thua vao cac cot. Mep phai
         phang, chip van deu nhau, va X van la be ngang toi thieu de ten the con
         doc duoc. Hang cuoi thieu chip thi cac o con lai giu nguyen be ngang
         cot chu khong gian ra — cai ma `flex: 1` se lam sai.
         KHONG con dem ngang: luoi cham dung hai mep khung hoi thoai. 3px cu la
         de vien chip khong sat mep cua so, nhung vien chip la `box-shadow:
         inset` (xem `.bonboz-chip-tat`) nen no ve BEN TRONG o chip — sat mep
         van thay du vien. Doi lai duoc them mot phan cot cho moi hang. -->
    <!-- BonBoZ: tran = 3 hang chip + gap 4px o moi nac giua cac hang
         (68=3x20+2x4, 74=3x22+2x4, 80=3x24+2x4); qua thi cuon trong khoi nay
         chu khong day khung chat len. Doi chieu cao chip thi phai doi tran theo
         dung cong thuc nay.
         Truoc la 2 hang: o soan tin ngoi het 64px nen luoi khong duoc an them.
         O soan gio con mot dong, cho tra ra du cho hang thu ba — voi bo tag
         hien tai (12 the) la vua het, khong con phai cuon de tim the. -->
    <div
      v-if="hienLuoi"
      class="grid grid-cols-[repeat(auto-fill,minmax(88px,1fr))] 2xl:grid-cols-[repeat(auto-fill,minmax(96px,1fr))] 3xl:grid-cols-[repeat(auto-fill,minmax(104px,1fr))] max-h-[64px] md:max-h-[68px] 2xl:max-h-[74px] 3xl:max-h-[80px] content-start gap-1 overflow-y-auto bonboz-cuon-manh"
    >
      <button
        v-for="label in labelsHien"
        :key="label.id"
        :title="
          isActive(label.title)
            ? $t('BONBOZ.TAG_GRID.REMOVE', { name: label.title })
            : $t('BONBOZ.TAG_GRID.ADD', { name: label.title })
        "
        class="bonboz-chip min-w-0 truncate px-2 md:px-[3px] 2xl:px-1 3xl:px-1.5 py-0 text-[12px] md:text-[11px] 2xl:text-[12px] 3xl:text-[13px] font-medium leading-[30px] md:leading-[20px] 2xl:leading-[22px] 3xl:leading-[24px] focus-visible:outline focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-n-brand"
        :class="isActive(label.title) ? 'bonboz-chip-bat' : 'bonboz-chip-tat'"
        :style="bienCssThe(label.color)"
        @click="toggle(label)"
      >
        {{ label.title }}
      </button>
    </div>
  </div>
</template>
